/**
 * Rule to check if the field is one of a given set of values
 * 
 * Usage: in:value_1,value_2
 * 
 */
export default {
    name     : 'in',
    validate : (value, data, parameters) => {
        //Using indexOf is a strict comparison
        return parameters.some(parameter => value == parameter)
    },
    message: (field, data, parameters) => `The field ${field} must be one of ${parameters.join(', ')}`
}